import React, { useState, useContext } from 'react'
import { useNavigate, Link } from "react-router-dom"

import { MeuContexto } from "../App"
import { global } from '../api/global'
import { data_user } from '../api/datauser'
import { data_email } from '../api/dataemail';
import { validar } from '../api/apiValidar'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Button from '../components/Button.jsx';
import Input from '../components/Input.jsx';
import CompActive from '../components/CompActive.jsx';

function PgSignIn() {
    let navigate = useNavigate();
    const { setlogado, setusername, setuser } = useContext(MeuContexto);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isRecovering, setIsRecovering] = useState(false);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    function _validar() {


        var retorno = true

        let formErrors = {};

        // Verificar se o e-mail está preenchido e é válido
        if (!email) {
            formErrors.email = 'Por favor, insira seu e-mail.';
            retorno = false
        } else if (!validateEmail(email)) {
            formErrors.email = 'Por favor, insira um e-mail válido.';
            retorno = false
        }

        // Verificar se a senha está preenchida
        if (!password) {
            formErrors.password = 'Por favor, insira sua senha.';
            retorno = false
        }

        // Se não houver erros, continue com o login
        if (Object.keys(formErrors).length === 0) {
          //  console.log('Login efetuado com sucesso!');
            // Aqui você pode adicionar a lógica de autenticação

            return true
        } else {
            setErrors(formErrors);
            return false
        }

    }

    async function _Logar(e) {
        e.preventDefault();
        if (!_validar()) {
            toast.warn('Favor verificar suas informações!');
            return;
        }

        setIsLoading(true);
        try {
            const resposta2 = await data_user.conectar({ email, password });
            
            if (resposta2) {
                global.token = resposta2.token;
                try {
                    localStorage.setItem('@smizetv:token', global.token);
                } catch (error) {
                    console.error('Erro ao salvar token:', error);
                }

                const isValidUser = await _validarme();
                if (isValidUser) {
                    setlogado(true);
                    toast.success('Login realizado com sucesso!');
                    navigate(-1);
                } else {
                    setlogado(false);
                    navigate("/");
                }
            }
        } catch (error) {
            console.error('Erro no login:', error);
            toast.error('Email ou senha incorretos. Tente novamente.');
        } finally {
            setIsLoading(false);
        }
    }
    async function _validarme() {
        const respostame = await data_user.me();
        if (respostame) {

            setuser(respostame)
            setusername(respostame.username)

            ///  console.log(respostame)
            if (respostame.banido) { return false } else { return true }
        }
        return false

    }



    function _validarRecuperarSenha() {


        if (!validar._email(email).valido) return false
        if (!validar._requerido(email).valido) return false


        return true
    }


    async function _recuperarsenha() {
        if (!_validarRecuperarSenha()) {
            toast.warn('Favor verificar o email informado!');
            return;
        }

        setIsRecovering(true);
        try {
            const resp = await data_user.novasenha(email);
            
            if (resp) {
                await data_email.rsenha(email, resp.senha);
                toast.success('Email enviado com a nova senha!');
            }
        } catch (error) {
            console.error('Erro na recuperação de senha:', error);
            toast.error('Erro ao enviar email. Tente novamente.');
        } finally {
            setIsRecovering(false);
        }
    }

    /*
        async function responseFacebook(response) {

            if (response) {

                if (response.accessToken) {


                    const resposta = await data_user.facebook({ faceid: response.id, faceemail: response.email, facename: response.name });

                    //////console.log(resposta, 'resposta face'        )

                    if (resposta) {


                        const resposta2 = await data_user.conectar(resposta);
                        ///    console.log(resposta2)
                        if (resposta2) {
                            global.token = resposta2.token
                            try {
                                localStorage.setItem('@smizetv:token', global.token);

                            } catch (error) {

                            }

                            if (_validarme()) {

                                setlogado(true)
                                navigate(-1)
                            } else {
                                setlogado(false)
                                navigate("/")
                            }

                        }

                    }



                }


            }


            //////console.log(response)




        }

        */
    function componentClicked() { }


    return (
        <main className="min-h-screen bg-background flex items-center justify-center p-4 selection:bg-primary/30">
            <div className="w-full max-w-md bg-surface border border-border rounded-2xl shadow-2xl p-8 animate-fade-in-up">
                {/* Header */}
                <div className="text-center mb-8">
                    <h1 className="text-4xl font-display font-bold text-text mb-2">
                        Bem-vindo de Volta
                    </h1>
                    <p className="text-text-subtle">
                        Faça login para continuar sua jornada.
                    </p>
                </div>

                {/* Form */}
                <form onSubmit={_Logar} className="space-y-6">
                    <Input
                        label="E-mail"
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="seu@email.com"
                        error={errors.email}
                        required
                        autoComplete="email"
                        disabled={isLoading}
                        className="bg-background"
                    />

                    <Input
                        label="Senha"
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Digite sua senha"
                        error={errors.password}
                        required
                        autoComplete="current-password"
                        disabled={isLoading}
                        className="bg-background"
                    />

                    <div className="flex items-center justify-between">
                        <div className="text-sm">
                            <button
                                type="button"
                                onClick={_recuperarsenha}
                                disabled={isRecovering}
                                className="font-medium text-primary-light hover:text-primary-dark transition-colors duration-200 focus:outline-none focus:underline"
                            >
                                {isRecovering ? 'Enviando...' : 'Esqueceu sua senha?'}
                            </button>
                        </div>
                    </div>

                    <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        className="w-full"
                        loading={isLoading}
                        disabled={isLoading || isRecovering}
                    >
                        {isLoading ? 'Entrando...' : 'Entrar'}
                    </Button>
                </form>

                {/* Footer */}
                <div className="text-center mt-8">
                    <p className="text-sm text-text-subtle">
                        Não tem uma conta?{' '}
                        <Link
                            to="/SignUp"
                            className="font-medium text-primary-light hover:text-primary-dark transition-colors duration-200 focus:outline-none focus:underline"
                        >
                            Cadastre-se
                        </Link>
                    </p>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </main>
    );
}

export default PgSignIn;